import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.UPDATE_STORE_MAPPING_BEGIN](state) {
    state.storeMappingUpdateState = API_STATES.REQUEST_PENDING;
  },
  [types.UPDATE_STORE_MAPPING_SUCCESS](state) {
    state.storeMappingUpdateError = null;
    state.storeMappingUpdateState = API_STATES.REQUEST_SUCCESS;
  },
  [types.UPDATE_STORE_MAPPING_ERROR](state, err) {
    state.storeMappingUpdateState = API_STATES.REQUEST_ERROR;
    state.storeMappingUpdateError = err;
  }
};

export default mutations;
